var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item',[_c('div',{staticClass:"d-inline-block"},[_c('span',{staticClass:"vertical-middle"},[_c('help-svg',{staticClass:"help-svg"})],1),_c('span',{staticClass:"text-help vertical-middle"},[_vm._v(" Help ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }